<template>
  <data-table 
    v-model="page"  
    :headers="headers" 
    :items="phones" 
    :loading="loading"
    @refresh="listPhoneNumbers"
    class="elevation-1">
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon small class="mr-2" @click="validatePhone(item)" v-if="!item.validated"> mdi-check </v-icon>
      <v-icon small color="red" @click="deletePhone(item)">
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
    </template>
  </data-table>
</template>

<script>
export default {
  data () {
    return {
      loading: true,
      headers: [
        {
          text: 'Phone number',
          align: 'start',
          sortable: false,
          value: 'phonenumber',
        },
        { text: 'label', value: 'label' },
        { text: 'status', value: 'validated' },
        { text: 'actions', value: 'actions' }
      ],
      phones: [],
    }
  },
  created() {
    this.listPhoneNumbers()
  },
  methods: {
    validatePhone(item) {
      this.$router.push({name: 'AddPhoneNumber', params: {label: item.label}})
    },
    deletePhone(item) {
      this.alert("confirm", `Please confirm to remove ${item.phonenumber} from your profile`, undefined, ()=> {
        this.$api.deleteUserPhonenumber(item.label, this.username, this.callBack(()=> {
          this.alert("info", `You successfully removed ${item.phonenumber} from your profile!`, undefined, undefined, this.listPhoneNumbers())
        }))
      })
    },
    listPhoneNumbers() {
      this.$api.getUserPhoneNumbers(this.username, false, this.callBack(response=> {
        response.forEach(item => item.validated = "")
        this.phones = response
        this.$api.getUserPhoneNumbers(this.username, true, this.callBack(response=> {
          response.forEach(item=> {
            this.phones.forEach(phone => {
              if (item.phonenumber == phone.phonenumber) phone.validated = "validated"
            })
          })
        }))
      }, undefined, ()=> {
        this.loading = false
      }))
    },

  }
}
</script>

<style scoped>
.v-data-table {
  width: fit-content;
  max-width: 100%;
}
</style>